import $ from 'jquery';
import 'slick-carousel'

export default class ProductCarousel {
    constructor() {
       this.$slider =  $('.product-carousel__products');
       this.$pagination = $('.product-carousel__pagination');
       this.minSliderWidth = 767;
       this.showing = false;

    //    if( $(window).width() > this.minSliderWidth ){
    //        this.initSlider();
    //    }

        this.initSlider();
        // $(window).on('resize orientationchange', (e) => {
        //     if( this.showing === true )
        //         this.$slider.slick('resize');

        //         this.initSlider();
            // if( $(window).width() > this.minSliderWidth && this.showing === false )
            // else if( $(window).width() <= this.minSliderWidth && this.showing === true )
            //     this.destroySlider();
        // });
    }

    initSlider() {
        if (this.$slider.hasClass('no-slider')) {
            return false;
        }
        this.showing = true;
        this.slideCount = this.$slider.find('.product-carousel__product').length;

        this.$slider.on('init', (e, slick) => {
            let pages = Math.ceil(slick.slideCount / slick.options.slidesToShow);
            let pButtons = [];

            for( let i = 1; i <= pages; i++ ){
                pButtons.push('<div data-page="'+i+'"></div>')
            }

            this.$pagination.html(pButtons);

            this.updatePagination(slick, 1);
        });

        let slidesToShowMob = (this.slideCount < 2 ) ? this.slideCount : 2;
        let slidesToShow = (this.slideCount < 3 ) ? this.slideCount : 3;

        this.$slider.slick({
            dots: false,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: slidesToShowMob,
            slidesToScroll: slidesToShowMob,
            prevArrow: $('.product-carousel__prev-arrow'),
            nextArrow: $('.product-carousel__next-arrow'),
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: slidesToShow,
                        slidesToScroll: slidesToShow
                    }
                },
                {
                    breakpoint: 300,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });


        this.$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            this.updatePagination(slick, ((nextSlide / slick.options.slidesToShow) + 1));
        });
    }

    updatePagination(slick, slideNum) {
        this.$pagination.find('div.active').removeClass('active');
        this.$pagination.find('div[data-page="'+slideNum+'"]').addClass('active');
    }

    destroySlider() {
        if( this.showing === true ){
            this.showing = false;

            this.$slider.slick('unslick');
        }
    }
}

new ProductCarousel();
